import { render, staticRenderFns } from "./gatewayDetailDialog.vue?vue&type=template&id=2f0e267a&scoped=true"
import script from "./gatewayDetailDialog.vue?vue&type=script&lang=js"
export * from "./gatewayDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e267a",
  null
  
)

export default component.exports